"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Description = exports.Title = exports.ContentContainer = exports.PageContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const PageContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
`;
exports.PageContainer = PageContainer;
const ContentContainer = styled_components_1.default.div `
  text-align: center;
`;
exports.ContentContainer = ContentContainer;
const Title = styled_components_1.default.h1 `
  font-size: 3rem;
  margin-bottom: 1.25rem;
`;
exports.Title = Title;
const Description = styled_components_1.default.p `
  font-size: 1.2rem;
`;
exports.Description = Description;
